
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import ConfirmationDialog from "../dialogs/confirmation-dialog.vue";
import MenuUploadAddPackagingChargeDialog from "../dialogs/menu-upload-add-packaging-charge-dialog.vue";
import MenuUploadAddVariantDialog from "../dialogs/menu-upload-add-variant-dialog.vue";
import MenuUploadPackagingChargeEligibleItemsDialog from "../dialogs/menu-upload-packaging-charge-eligible-items-dialog.vue";
import MenuUploadConfigureChargesItem from "./menu-upload-configure-charges-item.vue";
import { data } from "vue-barcode";
import MenuUploadPriceModifyDialog from "../dialogs/menu-upload-price-modify-dialog.vue";

export default {
  components: {
    MenuUploadConfigureChargesItem,
    MenuUploadAddPackagingChargeDialog,
    MenuUploadPackagingChargeEligibleItemsDialog,
    ConfirmationDialog,
    MenuUploadAddVariantDialog,
    MenuUploadPriceModifyDialog
  },
  data() {
    return {
      showAddPackagingChargeDialog: false,
      showEligibleItemDialog: false,
      packagingChargeAmount: 0,
      applyToOption: "single",
      filters: {
        withVariants: true,
        withoutVariants: true,
        withPackagingCharges: true,
        withoutPackagingCharges: true
      },
      selectedItem: null,
      selectedPackagingCharge: null,
      showPackageChargeDeleteConfirmationDialog: false,
      showAddVariantDialog: false,
      editingInfo: null,
      showVariantDeleteConfirmationDialog: false,
      showPackagingChargesUpdateDialog: false,
      showPriceModifyDialog: false
    };
  },
  beforeMount() {
    this.filters = JSON.parse(
      JSON.stringify(this.menuUploadConfigureChargesFilters)
    );
  },
  watch: {
    getConfiguredChargesFilteredItems: {
      handler(val) {
        this.filters = JSON.parse(
          JSON.stringify(this.menuUploadConfigureChargesFilters)
        );
      },
      deep: true
    }
  },
  computed: {
    ...mapState("menu", [
      "menuUploadList",
      "menuUploadConfigureChargesFilters"
    ]),
    ...mapGetters("menu", ["getConfiguredChargesFilteredItems"]),
    trueFilterCount() {
      return Object.values(this.filters).filter(Boolean).length;
    }
  },
  methods: {
    ...mapActions("menu", ["updateMenuUploadConfigureChargesFilters"]),
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),
    showPackagingDialog(item) {
      this.selectedItem = item;
      this.showAddPackagingChargeDialog = true;
    },
    handleShowPriceModifyDialog(item) {
      this.selectedItem = item;
      this.showPriceModifyDialog = true;
    },
    showVariantDialog(item) {
      this.selectedItem = item;
      this.showAddVariantDialog = true;
    },
    applyFilters() {
      this.updateMenuUploadConfigureChargesFilters(this.filters);
    },
    handleEligibleItemDialogClose() {
      this.showEligibleItemDialog = false;
      this.selectedItem = null;
      this.selectedPackagingCharge = null;
    },
    handleShowEligibleItemDialog(charge) {
      this.selectedPackagingCharge = charge;
      this.showAddPackagingChargeDialog = false;
      this.showEligibleItemDialog = true;
    },
    handleShowDeletePackagingChargeConfirmationDialog(item) {
      this.selectedItem = item;
      this.showPackageChargeDeleteConfirmationDialog = true;
    },
    handleDeletePackagingCharge() {
      const index = this.getMenuUploadItemIndex(
        this.menuUploadList,
        this.selectedItem.id
      );

      if (index !== -1) {
        this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
          index: index,
          propName: "package_charge",
          propValue: null
        });
      }
      this.showPackageChargeDeleteConfirmationDialog = false;
      this.selectedItem = null;
    },
    handleAddVariantialogClose() {
      this.showAddVariantDialog = false;
      this.selectedItem = null;
      this.editingInfo = null;
    },
    handleOpenAddNewVariantDialog() {
      this.showAddVariantDialog = false;
      this.editingInfo = null;
      this.$nextTick(() => {
        this.showAddVariantDialog = true;
      });
    },
    handleShowVariantModifyDialog(info, item) {
      this.editingInfo = info;
      this.selectedItem = item;
      this.showAddVariantDialog = true;
    },
    handleShowDeletVariantConfirmationDialog(info, item) {
      this.editingInfo = info;
      this.selectedItem = item;
      this.showVariantDeleteConfirmationDialog = true;
    },
    handleUpdatePackagingCharge() {
      this.showPackagingChargesUpdateDialog = true;
      this.showAddVariantDialog = false;
      this.editingInfo = null;
    },
    handleUpdatePackagingChargeAfterPriceUpdate() {
      this.showPackagingChargesUpdateDialog = true;
      this.showPriceModifyDialog = false;
    },
    proceedWithPackagingChargesUpdate() {
      this.showAddPackagingChargeDialog = true;
      this.showPackagingChargesUpdateDialog = false;
    },
    discardPackagingCharge() {
      this.handleDeletePackagingCharge();
      this.showPackagingChargesUpdateDialog = false;
    },
    handleAddPackagingChargeDialogClose() {
      this.showAddPackagingChargeDialog = false;
      this.selectedItem = null;
    },
    handleDeleteVariant() {
      const index = this.getMenuUploadItemIndex(
        this.menuUploadList,
        this.selectedItem.id
      );

      if (index !== -1) {
        const menuUploadList = JSON.parse(JSON.stringify(this.menuUploadList));
        const currentVariants = menuUploadList[index].variants || [];

        const updatedVariants = currentVariants.filter(
          (variant) => variant.name !== this.editingInfo.name
        );
        this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
          index: index,
          propName: "variants",
          propValue: updatedVariants
        });
      }
      this.showVariantDeleteConfirmationDialog = false;
      this.selectedItem = null;
      this.editingInfo = null;
    }
  }
};
